import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Briefcase, ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";
import { CAREER_SECTION } from "@/constants/testIds";

export const CareersSection = () => {
  const [careers, setCareers] = useState([]);

  useEffect(() => {
    api
      .get("/careers")
      .then((r) => setCareers(r.data))
      .catch(() => setCareers([]));
  }, []);

  if (careers.length === 0) return null;

  return (
    <section
      id="careers"
      data-testid={CAREER_SECTION.section}
      className="py-24 md:py-32 px-6 md:px-10 max-w-7xl mx-auto"
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="mb-14 max-w-2xl"
      >
        <p className="text-xs md:text-sm uppercase tracking-[0.2em] font-bold text-[#D97736] mb-4">
          Join The Kennel Team
        </p>
        <h2 className="font-display text-4xl md:text-5xl font-bold tracking-tight text-[#0F2520]">
          Open Career Opportunities
        </h2>
      </motion.div>

      <div className="grid md:grid-cols-2 gap-6">
        {careers.map((c, i) => (
          <motion.div
            key={c.id}
            data-testid={CAREER_SECTION.card(c.id)}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.08 }}
          >
            <Link
              to={`/careers/${c.id}`}
              className="block bg-[#0F2520] text-white rounded-[2rem] p-8 hover:scale-[1.02] transition-transform duration-300"
            >
              <Briefcase className="w-8 h-8 text-[#F4D06F] mb-4" />
              <h3 className="font-display text-2xl font-semibold mb-2">{c.title}</h3>
              <p className="font-light text-white/70 mb-4 line-clamp-2">{c.qualification}</p>
              <div className="flex items-center justify-between mt-4">
                <span className="text-[#F4D06F] font-semibold">₹{c.price} application form</span>
                <ArrowUpRight className="w-5 h-5 text-[#F4D06F]" />
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
